import { render, staticRenderFns } from "./TabSlider.vue?vue&type=template&id=51083168"
import script from "./TabSlider.js?vue&type=script&lang=js&external"
export * from "./TabSlider.js?vue&type=script&lang=js&external"
import style0 from "./TabSlider.vue?vue&type=style&index=0&id=51083168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports